import { styled, Typography } from "@mui/material";

export const TitleTypography = styled(Typography)(({ theme }) => ({
  "-webkit-box-orient": "vertical",
  "-webkit-line-clamp": "3",
  color: theme.customColors.exploreCardText,
  display: "-webkit-box",
  fontSize: "1rem",
  fontStyle:"normal",
  fontWeight: 700,
  lineHeight:"1.3125rem",
  overflow: "hidden",
  overflowWrap:"break-word",
  textOverflow: "ellipsis",
  whiteSpace:"initial"
}));

